// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d2cbd49c","455":"091f05cb","644":"6cc4af84"}[chunkId] + ".chunk.js";
};